type AdditionalInfoStatusProps = {
  isPending: boolean
  isError: boolean
  endorsementCount: number
  errorMessage: string | null
  selectionError: string | null
}

export function AdditionalInfoStatus({
  isPending,
  isError,
  endorsementCount,
  errorMessage,
  selectionError
}: AdditionalInfoStatusProps) {
  return (
    <>
      {isPending ? (
        <div className="mb-4 rounded-2xl border border-gray-lighter bg-white px-4 py-6 text-center text-sm text-gray-dark">
          Loading endorsements...
        </div>
      ) : null}

      {isError ? (
        <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-600">
          Unable to load endorsements right now. Please try again later.
        </div>
      ) : null}

      {!isPending && !isError && endorsementCount === 0 ? (
        <div className="mb-4 rounded-2xl border border-gray-lighter bg-white px-4 py-6 text-center text-sm text-gray-dark">
          No endorsements are currently available.
        </div>
      ) : null}

      {errorMessage ? (
        <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-600">
          {errorMessage}
        </div>
      ) : null}

      {selectionError ? (
        <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-600">
          {selectionError}
        </div>
      ) : null}
    </>
  )
}
